import { AnyAction, createSlice } from '@reduxjs/toolkit';
import { ApiError } from '../../services/api';
import { RootState } from '../rootReducer';
import { IUser } from './user';
import {
  fetchUsersListToExport
} from './usersToExport.thunks';

export interface UserListState {
  users: IUser[];
  loading: boolean;
  error: ApiError | null;
}

const initialState: UserListState = {
  error: null,
  loading: false,
  users: []
};

const getUsersToExportState = (state:RootState):UserListState => state.users.usersToExport;
const getError = (state:RootState):ApiError | null => getUsersToExportState(state).error;
const getUsersToExport = (state:RootState):IUser[] => getUsersToExportState(state).users;
const getLoading = (state:RootState):boolean => getUsersToExportState(state).loading;

export const selectors = {
  getError,
  getUsersToExport,
  getLoading
};

export const extraReducers = {
  [fetchUsersListToExport.pending.type]: (state: UserListState):void => {
    state.loading = true;
    state.users = [];
  },
  [fetchUsersListToExport.fulfilled.type]: (state: UserListState, action: AnyAction):void => {
    state.loading = false;
    state.users = action.payload.users;
  },
  [fetchUsersListToExport.rejected.type]: (state: UserListState, action: AnyAction):void => {
    state.loading = false;
    state.error = action.payload;
  }
};

const usersToExportSlice = createSlice({
  name: 'usersListToExport',
  initialState,
  reducers: {},
  extraReducers
});

export default usersToExportSlice.reducer;
export const actions = {
  ...usersToExportSlice.actions,
  fetchUsersListToExport
};
